// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 1024px;
  margin: 0 auto;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/container/qr/qr.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,cAAA;EACA,UAAA;AACJ","sourcesContent":[".container {\n    max-width: 1024px;\n    margin: 0 auto;\n    padding: 0\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
